module.exports = __webpack_public_path__ + "img/21.9b70ea24.jpg";